import { type AxiosResponse } from 'axios'
const ERRORS_LANG: Record<string, string> = {
  404: 'Страница не найдена',
  401: 'Неавторизованный запрос',
  403: 'Доступ к ресурсу запрещен',
  413: 'Превышен размер выполняемого запроса'
}

class AxiosCustomError extends Error {
  name: string
  response: AxiosResponse
  code: string

  constructor(
    response: AxiosResponse,
    message = 'Invalid response type',
    code = ''
  ) {
    const preDefinedMessage = ERRORS_LANG[String(response.status)]
    if (preDefinedMessage !== '') {
      super(preDefinedMessage)
    } else {
      super(message)
    }

    this.response = { ...{ status: 500 }, ...response }
    this.name = 'AxiosCustomError'
    this.message = message
    this.code = code
  }
}

export { AxiosCustomError, ERRORS_LANG }
